export const PROD_IEFROME = 'Magnet.Tests.Ui.Iefrome';
export const PROD_ROME = 'Magnet.Tests.Ui.Rome';
export const PROD_IEF = 'Magnet.Tests.Ui.Ief';
export const PROD_IEFRV = 'Magnet.Tests.Ui.Iefrv';
export const PROD_INSTALLER = 'Installer';

export const TITLE_IEFROME = 'Process';
export const TITLE_ROME = 'Examine';
export const TITLE_IEF = 'IEF';
export const TITLE_IEFRV = 'IEF RV';
export const TITLE_INSTALLER = 'Installer';

export const PRODUCT_TITLES = {
  [PROD_IEFROME]: TITLE_IEFROME,
  [PROD_ROME]: TITLE_ROME,
  [PROD_IEF]: TITLE_IEF,
  [PROD_IEFRV]: TITLE_IEFRV,
  [PROD_INSTALLER]: TITLE_INSTALLER
};


// WEBPACK FOOTER //
// src/helpers/white.js